import { render, staticRenderFns } from "./statisticsSells.vue?vue&type=template&id=19b32a58&scoped=true&"
import script from "./statisticsSells.vue?vue&type=script&lang=js&"
export * from "./statisticsSells.vue?vue&type=script&lang=js&"
import style0 from "./statisticsSells.vue?vue&type=style&index=0&id=19b32a58&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b32a58",
  null
  
)

export default component.exports